import {z} from 'zod';

export const GetVehicleRelatedRecordCountResponseBodySchema = z.object({
  documents: z.number(),
  interests: z.number(),
  testDrives: z.number(),
  businessCases: z.number(),
  campaigns: z.number(),
  rentalOrders: z.number().optional(),
});
export const GetVehicleRelatedRecordCountApiArgSchema = z.object({
  vehicleId: z.string(),
});
export const GetVehicleRelatedRecordCountApiResponseSchema =
  GetVehicleRelatedRecordCountResponseBodySchema;
export type GetVehicleRelatedRecordCountApiResponse = z.infer<
  typeof GetVehicleRelatedRecordCountApiResponseSchema
>;
export type GetVehicleRelatedRecordCountResponseBody = z.infer<
  typeof GetVehicleRelatedRecordCountResponseBodySchema
>;
export type GetVehicleRelatedRecordCountApiArg = z.infer<
  typeof GetVehicleRelatedRecordCountApiArgSchema
>;
